<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
  },
  components: {},
  data() {
    return {
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    selectedItem: {
      handler(val) {
        this.d_check = val ? val[this.item.displayOn] : false;
      },
      deep: true,
    },
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  mounted() {
    this.item.display = false;
    if (this.selectedItem?.days && !this.selectedItem.days.length) {
      console.log("mounted called");
    }
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{ 'd-none': item.displayOn && !display_none_check }"
  >
    <div class="row" v-for="day of selectedItem.days" v-bind:key="day.day">
      <div class="d-flex col-12 px-0 mt-2">
        <div class="col-2">
          <div class="badge font-size-16 mr-1">
            <input type="checkbox" v-model="day.active" v-bind:id="day.day" />
          </div>
          <label
            class="pr-2 mt-5 align-self-sm-center font-theme-black-color font-weight-medium"
          >
            {{ day.day }}
          </label>
        </div>
        <div class="col-5">
          <label
            class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
          >
            Start Time
          </label>
          <img
            variant="primary"
            class="align-self-center"
            src="@/assets/images/info.svg"
            alt=""
          />
          <input
            v-model="day.start_time"
            type="time"
            class="form-control"
            :class="{ 'bg-soft-secondary': !day.active }"
            :disabled="!day.active"
          />
        </div>
        <div class="col-5">
          <label
            class="pr-2 my-2 align-self-sm-center font-theme-black-color font-weight-medium"
          >
            End Time
          </label>
          <img
            variant="primary"
            class="align-self-center"
            src="@/assets/images/info.svg"
            alt=""
          />
          <input
            v-model="day.end_time"
            type="time"
            class="form-control"
            :class="{ 'bg-soft-secondary': !day.active }"
            :disabled="!day.active"
          />
        </div>
      </div>
    </div>
  </div>
</template>
